import type { TypeTask } from '@/types/work/types.work.task';

type TypeLocal = { seq: number; sent: number; flying: number; fields: Set<string> };

const locals = new Map<string, TypeLocal>();

const localOf = (taskId: string): TypeLocal => {
    const found = locals.get(taskId);
    if (found) return found;
    const fresh: TypeLocal = { seq: 0, sent: 0, flying: 0, fields: new Set() };
    locals.set(taskId, fresh);
    return fresh;
};

export function touchLocal(taskId: string, fields: string[]): number {
    const local = localOf(taskId);
    local.seq += 1;
    fields.forEach((field) => local.fields.add(field));
    return local.seq;
}

export function sendLocal(taskId: string): number {
    const local = localOf(taskId);
    local.sent = local.seq;
    local.flying += 1;
    return local.seq;
}

export function settleLocal(taskId: string): void {
    const local = localOf(taskId);
    local.flying = Math.max(0, local.flying - 1);
    if (!local.flying && local.sent === local.seq) locals.delete(taskId);
}

export function latestLocal(taskId: string): number {
    return locals.get(taskId)?.seq ?? 0;
}

export function shieldTask(incoming: TypeTask, current: TypeTask | undefined, answering?: number): TypeTask {
    const local = locals.get(incoming.id);
    if (!local || !current || !local.fields.size) return incoming;
    const newer = answering === undefined ? local.flying > 0 || local.seq > local.sent : local.seq > answering;
    if (!newer) return incoming;
    const kept = { ...incoming } as Record<string, unknown>;
    local.fields.forEach((field) => { kept[field] = (current as unknown as Record<string, unknown>)[field]; });
    return kept as unknown as TypeTask;
}
